import { t } from "i18next";
import '../../i18n';

export const getReportsTypes = () => ({
    types: [
        {
            title: t('ENTRY_DEPARTURE'),
            subtitle: t('MOV_DETAIL'),
            backRoute: '/reports',
            redirection: 'entryAndDeparture',
            haveAccess: 6
        },
        {
            title: t('PERMANENCE'),
            subtitle: t('RES_PERMANENCE_DETAIL'),
            backRoute: '/reports',
            redirection: 'permanence',
            haveAccess: 5
        }
    ]
})